import {troops, foods} from "./Vars";

export default function CalculatorLogic(inputs, logicType) {
  const multiplier = {
    'k': 1,
    'm': 2,
    'b': 3,
    't': 4,
  };
  const suffixes = [
      "", "k", "m", "b", "t", "A", "B", "C", "D", "E", "F", "G",
      "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S",
      "T", "U", "V", "W", "X", "Y", "Z", "AA", "AB", "AC", "AD", "AE",
      "AF", "AG", "AH", "AI", "AJ", "AK", "AL", "AM", "AN", "AO", "AP", "AQ", 
      "AR", "AS", "AT", "AU", "AV", "AW", "AX", "AY", "AZ", "BA", "BB", "BC", 
      "BD", "BE", "BF", "BG", "BH", "BI", "BJ", "BK", "BL", "BM", "BN", "BO", 
      "BP", "BQ", "BR", "BS", "BT", "BU", "BV", "BW", "BX", "BY", "BZ", "CA",
      "CB", "CC", "CD", "CE", "CF", "CG", "CH", "CI", "CJ", "CK", "CL", "CM", 
      "CN", "CO", "CP", "CQ", "CR", "CS", "CT", "CU", "CV", "CW", "CX", "CY", 
      "CZ", "DA", "DB", "DC", "DD", "DE", "DF", "DG", "DH", "DI", "DJ", "DK", 
      "DL", "DM", "DN", "DO", "DP", "DQ", "DR", "DS", "DT", "DU", "DV", "DW", 
      "DX", "DY", "DZ", "EA", "EB", "EC", "ED", "EE", "EF", "EG", "EH", "EI", 
      "EJ", "EK", "EL", "EM", "EN", "EO", "EP", "EQ", "ER", "ES", "ET", "EU", 
      "EV", "EW", "EX", "EY", "EZ"
    ];
  const bosses = {
    1: {
      name: "GigaRex",
      attk: 32.09,
      attk2: 128.38
    },
    2: {
      name: "Medusa",
      attk: 111.2,
      num: 4,
      attk2: 66.20,
      option: "snakes"
    },
    3: {
      name: "Dragon",
      attk: 295,
      num: 3,
      attk2: 5546
    },
    4: {
      name: "Spider",
      attk: 7620,
      attk2: 3810,
      option: "spiderling"
    },
    5: {
      name: "Yeti",
      attk: 47175,
      attk2: 169830,
    }
  }
  const zombies = {
    1: {
      attk: 1.388,
      attk2: 3.453,
      attk3: 7.63
    },
    2: {
      attk: 6.88,
      attk2: 21.49,
      attk3: 55.55
    },
    3: {
      attk: 53.22,
      attk2: 155.88,
      attk3: 257.8
    },
    4: {
      attk: 374.4,
      attk2: 725,
      attk3: 1810
    },
    5: {
      attk: 2307,
      attk2: 5072,
      attk3: 11166
    },
    6: {
      attk: 14340,
      attk2: 36990,
      attk3: 69040
    },
    7: {
      attk: 88450,
      attk2: 194600,
      attk3: 352000
    },
    8: {
      attk: 548000,
      attk2: 711000,
      attk3: 4690000
    },
    9: {
      attk: 3000000,
      attk2: 6602000,
      attk3: 16405000
    },
    /// not optimized
    10: {
      attk: 18575000,
      attk2: 46200000,
      attk3: 101600000
    },
    "quantity": {
      1: {
        unit1: 11,
        unit2: 0,
        unit3: 0
      },
      2: {
        unit1: 11,
        unit2: 1,
        unit3: 0
      },
      3: {
        unit1: 11,
        unit2: 2,
        unit3: 0
      },
      4: {
        unit1: 12,
        unit2: 2,
        unit3: 0
      },
      5: {
        unit1: 11,
        unit2: 4,
        unit3: 0
      },
      6: {
        unit1: 11,
        unit2: 5,
        unit3: 1
      },
      7: {
        unit1: 11,
        unit2: 6,
        unit3: 2
      },
      8: {
        unit1: 17,
        unit2: 3,
        unit3: 0
      },
      9: {
        unit1: 11,
        unit2: 8,
        unit3: 4
      },
      10: {
        unit1: 11,
        unit2: 8,
        unit3: 5
      },
    }
  }
  function lettersToNumber(input) {
    const match = input.match(/([A-Za-z]{1,2})$/);
    if (!match && !isNaN(input)) return 0;
    else if (!match) return null;

    const letters = match[1];
    let value, result;

    if (letters.length === 1 && letters in multiplier) {
      return multiplier[letters];
    }

    for (let i = 0; i < letters.length; i++) {
      const char = letters[i];
      if (char >= 'A' && char <= 'Z') {
        value = char.charCodeAt(0) - 60; // A=5, B=6, ..., Z=31
      } else {
        value = null;
      }

      if (i === 0) {
        result = value;
      } else {
        result = (result - 4) * 26 + value;
      }
    }

    return result;
  }
  function formatLargeNumber(num, precision = 3, t = false ) {
    
    if (num === 0) return "0";
    if (num < 1000 && !t) return num.toPrecision(precision);
  
    const tier = Math.floor(Math.log10(Math.abs(num)) / 3);
    const suffix = suffixes[tier] || `e${tier * 3}`;
    const scaled = num / Math.pow(10, tier * 3);
    if (!t) {
      return scaled.toPrecision(precision) + suffix;
    }
    return [scaled.toPrecision(precision), tier]; 
  }
  function extractNumber(input) {
    const match = input.match(/^(\d+(\.\d+)?)/);    
    return match ? parseFloat(match[1], 10) : null;
  }
  function getUpgradeStats(comparison, multiplier, startBaseCost, maxResource, age) {
    let upgrades = 0;
    let totalCost = 0;
    let finalCost = 0;
    const target = multiplier * 1/comparison;
    if (multiplier <= 17 && age === 1) {
      upgrades = Math.round(target) - 1;
    } else {
      upgrades = Math.round(Math.log(target) / Math.log(1.15));
    }
    upgrades = upgrades < 1 ? 0 : upgrades;
    totalCost = upgrades < 2
      ? startBaseCost
      : Math.round(startBaseCost * (1 - Math.pow(1.2, upgrades)) / (1 - 1.2));
    totalCost = upgrades < 1 ? 0 : totalCost;
    finalCost = upgrades < 1 ? 0 : Math.round(startBaseCost * Math.pow(1.2, upgrades - 1));
    const possible = finalCost <= maxResource ? 'yes' : 'no';

    return { upgrades, totalCost, finalCost, possible };
  }
  const convertedValues = inputs.map((input) => {
    const base = extractNumber(input);
    const power = lettersToNumber(input);
    return base * Math.pow(1000, power);
  });

    let result;
    switch (logicType) {
      case "Attack To Timeline":
        const attack = convertedValues[0];
        const enemyAge1 = Math.log(attack)/Math.log(1.2)+2
        const enemyAge2 = Math.log(attack*10)/Math.log(1.2)+2
        const enemyAge3 = Math.log(attack*30)/Math.log(1.2)+2
        const enemat1 = Math.pow(1.2,Math.floor(enemyAge1)-2)
        const enemat2 = Math.pow(1.2,Math.floor(enemyAge2)-2)
        const enemat3 = Math.pow(1.2,Math.floor(enemyAge3)-2)
        result = {
          rows: [
            { name: "Enemy has same Attack Stat", val: `About Timeline ${Math.floor(enemyAge1)} (${formatLargeNumber(enemat1)}) to Timeline ${Math.ceil(enemyAge1)} (${formatLargeNumber(enemat1*1.2)})` },
            { name: "Enemy is 10x stronger", val: `About Timeline ${Math.floor(enemyAge2)} (${formatLargeNumber(enemat2)}) to Timeline ${Math.ceil(enemyAge2)} (${formatLargeNumber(enemat2*1.2)})` },
            { name: "Enemy is 30x stronger", val: `About Timeline ${Math.floor(enemyAge3)} (${formatLargeNumber(enemat3)}) to Timeline ${Math.ceil(enemyAge3)} (${formatLargeNumber(enemat3*1.2)})` },
          ]
        };        
        break;
      case "Attack Vs Attack":
        const attack1 = convertedValues[0];
        const enemyAttack = convertedValues[1];
        const attack3 = attack1 * 30;
        const attack2 = attack1 * 10;
        const multi = attack1/enemyAttack;
        if (attack3 < enemyAttack){
          result = {
          rows: [
            { name: "Your Attack Stat is too low to match the enemy", val: "0 potions and 0 trophies" },
            { name: "Your Attack Stat x 10 is too low to match the enemy", val: "0 potions and 0 trophies" },
            { name: "Your Attack Stat x 30 is too low to match the enemy", val: "0 potions and 0 trophies" },
            { name: "Final Verdict", val: `The enemies attack is ${formatLargeNumber(1/multi)} times stronger. Increase your attack stat or check base health` }
          ]
        };
          break;
        }
        const multi3 = attack3/enemyAttack;
        const ageUp3 = Math.round(Math.log(multi3)/Math.log(1.2));
        if (attack2 < enemyAttack){
          result = {
          rows: [
            { name: "Your Attack Stat is too low to match the enemy", val: "0 potions and 0 trophies" },
            { name: "Your [Attack Stat x 10] is too low to match the enemy", val: "0 potions and 0 trophies" },
            { name: `Your [Attack Stat x 30] is possible, you can advance ${ageUp3} TL until they match this`, val: `${54*ageUp3} potions and ${15*ageUp3} trophies` },
            { name: "Final Verdict", val: `The enemies attack is ${formatLargeNumber(1/multi)} times stronger. Might be possible in main timeline, but could be a struggle. Increase attack stat or check base health` }
          ]
        };
          break;
        }
        const multi2 = attack2/enemyAttack; 
        const ageUp2 = Math.round(Math.log(multi2)/Math.log(1.2));
        if (attack1 < enemyAttack){
          result = {
          rows: [
            { name: `Your Attack Stat is too low to match the enemy`, val: `0 potions and 0 trophies`},
            { name: `Your [Attack Stat x 10] is higher than the enemies, you can advance ${ageUp2} TL until they match this`, val: `${54*ageUp2} potions and ${15*ageUp2} trophies`},
            { name: `Your [Attack Stat x 30] is higher than the enemies, you can advance ${ageUp3} TL until they match this`, val: `${54*ageUp3} potions and ${15*ageUp3} trophies` },
            { name: "Final Verdict", val: `The enemies attack is ${formatLargeNumber(1/multi)} times stronger. You might get some trophies. Good luck.` }
          ]
        }
          break;
        }
        
        const ageUp = Math.round(Math.log(multi)/Math.log(1.2)); 
        result = {
          rows: [
            { name: `Your Attack Stat is higher than the enemies, you can advance ${ageUp} TL until they match you`, val: `${54*ageUp} potions and ${15*ageUp} trophies`},
            { name: `Your [Attack Stat x 10] is higher than the enemies, you can advance ${ageUp2} TL until they match this`, val: `${54*ageUp2} potions and ${15*ageUp2} trophies`},
            { name: `Your [Attack Stat x 30] is higher than the enemies, you can advance ${ageUp3} TL until they match this`, val: `${54*ageUp3} potions and ${15*ageUp3} trophies` },
            { name: "Final Verdict", val: `Your attack is ${formatLargeNumber(multi)} times stronger. Have fun.` }
          ]
        };
        break;
      case "Check TL Stats":
        const enemyTL = convertedValues[0];
        let enemyAtt;
        let enemyBase;
        let enemyAtt10;
        let enemyBase10;
        let enemyAtt30;
        let enemyBase30;
        if (enemyTL > 3000){
          const enemyTL2 = enemyTL/2;
          const enemyAtt2 = Math.pow(1.2, enemyTL2 -1);
          const enemyNumbers = formatLargeNumber(enemyAtt2, 12, true);
          const enemyAtt3 = Math.pow(enemyNumbers[0], 2);
          const enemyTiers = enemyNumbers[1] * 2;
          const enemyNumbers2 = formatLargeNumber(enemyAtt3, 12, true);
          const enemyTier2 = enemyTiers + enemyNumbers2[1];
          
          enemyAtt = `${(enemyNumbers2[0]*1).toPrecision(3)} ${suffixes[enemyTier2]}`;  
          
          let enemyBaseCoe = enemyNumbers2[0]* 500;
          let enemyBaseTier = enemyTier2; 
          if(enemyBaseCoe > 1000) {
            enemyBaseCoe = enemyBaseCoe/1000;
            enemyBaseTier += 1; 
          }
          enemyBase = `${enemyBaseCoe.toPrecision(3)}  ${suffixes[enemyBaseTier]}`

          let enemyAttCoe10 = enemyNumbers2[0] / 10;
          let enemyAttTier10 = enemyTier2;
          enemyAttTier10 = enemyAttCoe10 < 1 ? enemyAttTier10 - 1 : enemyAttTier10;
          enemyAttCoe10 = enemyAttCoe10 < 1 ? enemyAttCoe10 * 1000 : enemyAttCoe10; 
          enemyAtt10 = `${enemyAttCoe10.toPrecision(3)}${suffixes[enemyAttTier10]}`;

          let enemyBaseCoe10 = enemyNumbers2[0] * 50;
          let enemyBaseTier10 = enemyTier2;
          enemyBaseTier10 = enemyBaseCoe10 > 1000 ? enemyBaseTier10 + 1 : enemyBaseTier10; 
          enemyBaseCoe10 = enemyBaseCoe10 > 1000 ? enemyBaseCoe10/1000 : enemyBaseCoe10;
          enemyBase10 = `${enemyBaseCoe10.toPrecision(3)} ${suffixes[enemyBaseTier10]}`;

          let enemyAttCoe30 = enemyNumbers2[0] / 30;
          let enemyAttTier30 = enemyTier2;
          enemyAttTier30 = enemyAttCoe30 < 1 ? enemyAttTier30 - 1 : enemyAttTier30;
          enemyAttCoe30 = enemyAttCoe30 < 1 ? enemyAttCoe30*1000 : enemyAttCoe30; 
          enemyAtt30 = `${enemyAttCoe30.toPrecision(3)} ${suffixes[enemyAttTier30]}`;

          let enemyBaseCoe30 = enemyNumbers2[0] * 500 / 30;
          let enemyBaseTier30 = enemyTier2;
          enemyBaseTier30 = enemyBaseTier30 > 1000 ? enemyBaseTier30 + 1 : enemyBaseTier30; 
          enemyBaseCoe30 = enemyBaseCoe30 > 1000 ? enemyBaseCoe30/1000 : enemyBaseCoe30;
          enemyBase30 = `${enemyBaseCoe30.toPrecision(3)}${suffixes[enemyBaseTier30]}`;

        }
        else if (enemyTL < 2){
          enemyAtt = 1;
          enemyBase = 500;
          enemyAtt10 = 10;
          enemyBase10 = formatLargeNumber(500/10);
          enemyAtt30 = 30;
          enemyBase30 = formatLargeNumber(500/30);
        }
        else {
          enemyAtt = formatLargeNumber(Math.pow(1.2, enemyTL- 2));
          enemyBase = formatLargeNumber(500 * Math.pow(1.2, enemyTL- 2));
          enemyAtt10 = formatLargeNumber(Math.pow(1.2, enemyTL- 2)/10);
          enemyBase10 = formatLargeNumber(50*Math.pow(1.2, enemyTL- 2));
          enemyAtt30 = formatLargeNumber(Math.pow(1.2, enemyTL- 2)/30);
          enemyBase30 = formatLargeNumber(500/30*Math.pow(1.2, enemyTL- 2));
        }
        
        let ageNum = parseInt(enemyTL % 21); 
        ageNum = ageNum === 0 ? 21 : ageNum;
        const enemyAgeList = troops[ageNum];
        const foodAge1t1 = Math.round(foods[1][0]*enemyTL + foods[1][1]);
        const foodAge1t2 = Math.round(foods[2][0]*enemyTL + foods[2][1]);
        const foodAge1t3 = Math.round(foods[3][0]*enemyTL + foods[3][1]);
        let foodAge1 = `Troop 1: ${foodAge1t1}, Troop 2: ${foodAge1t2}, Troop 3: ${foodAge1t3}`;
        // 2, 11, 16
        let worldWarsNext;
        if([2, 11, 16].includes(ageNum)){
          worldWarsNext = "You are in a FlameThrower Timeline";
        }  
        else if(ageNum < 2){
          worldWarsNext = `FlameThrower Timeline is next, ${enemyTL + 1}`;
        }
        else if (ageNum < 11){
          worldWarsNext = `FlameThrower Timeline in ${11-ageNum} timelines: ${enemyTL + 11 - ageNum}`;
        }
        else if (ageNum < 16){
          worldWarsNext = `FlameThrower Timeline in ${16-ageNum} timelines: ${enemyTL + 16 - ageNum}`;
        }
        else {
          worldWarsNext = `FlameThrower Timeline in ${23-ageNum} timelines: ${enemyTL + 23 - ageNum}`;
        }
        result = {
          rows: [
            { name: 'Enemy Troops by Age', val: enemyAgeList.join(", ")},
            { name: 'Next World War Timeline', val: worldWarsNext},
            { name: 'Food cost at age 1 (testing and updating with more values)', val: foodAge1},
            { name: `Enemy Attack and Base Health`, val: `${enemyAtt} Attack and ${enemyBase} Base Health`},
            { name: `Enemy Attack and Base Health /10`, val: `${enemyAtt10} Attack and ${enemyBase10} Base Health`},
            { name: `Enemy Attack and Base Health /30`, val: `${enemyAtt30} Attack and ${enemyBase30} Base Health` },
          ]
        };
        break;
      case "Base Health Catch Up":
        const enemyTLMulti = convertedValues[2] < 3 ? 1 : Math.pow(1.2, convertedValues[2]-2);
        const enemyAgeMulti = Math.pow(3, convertedValues[3]-1) * 500;
        const yourAgeMulti =  Math.pow(3, convertedValues[0]-1) * 2; 
        const startBaseCost = Math.pow(8, convertedValues[0]-1) * 40; 
        const yourAge = convertedValues[0];
        const enemyBaseHealth = enemyTLMulti * enemyAgeMulti;
        const maxRes = convertedValues[4]; 
        const yourBaseHealth = convertedValues[1] * yourAgeMulti;
        let maxUpgrades = Math.round(Math.log(convertedValues[4]/startBaseCost)/Math.log(1.2)); 
        maxUpgrades = maxUpgrades < 1 ? 1 : maxUpgrades;
        const matchingEnemyTL = Math.round(Math.log(yourBaseHealth/(enemyAgeMulti))/Math.log(1.2))+2;
        const reasonableEnemyTL = Math.round(Math.log(yourBaseHealth*1.15*Math.pow(1.15, maxUpgrades)/(243*500))/Math.log(1.2))+1
        const customBase = Math.ceil(yourBaseHealth/enemyBaseHealth) + 1; 
        let comparison = yourBaseHealth / enemyBaseHealth;
        result = { rows: [] };
        if (comparison > 6) {
          const stats = getUpgradeStats(comparison, 1/comparison+1, startBaseCost, maxRes, yourAge);
          const formattedComparison = comparison < 100 ? comparison.toPrecision(3) : formatLargeNumber(comparison);
          result.rows.push(
            { name: `Your base health (${formatLargeNumber(yourBaseHealth)}) is bigger than the enemies (${formatLargeNumber(enemyBaseHealth)}) by ${formattedComparison}`, val: `The enemy will catch up at TL ${matchingEnemyTL}.` },
            { name: `Your base health can get x${formatLargeNumber(customBase)} the enemies by ${stats.upgrades} upgrades`, val: `This costs ${formatLargeNumber(stats.totalCost)} in total, with final cost of ${formatLargeNumber(stats.finalCost)}, possible: ${stats.possible}` },
            { name: `A reasonable but naive enemy TL`, val: `Enemy timeline: ${reasonableEnemyTL}` }
          );
        } else {
          const formattedComparison2 = 1/comparison < 100 ? (1/comparison).toPrecision(3) : formatLargeNumber(1/comparison);
          result.rows.push({ name: `Your base health (${formatLargeNumber(yourBaseHealth)}) is comparable to ( x${formattedComparison2}) the enemy base health (${formatLargeNumber(enemyBaseHealth)}) ` });
          // Loop upgrades from comparison to 6 (integer steps)
          const testStat = getUpgradeStats(comparison, 1, startBaseCost, maxRes, yourAge);
          if (testStat.possible === "yes"){
          for (let targetRatio = Math.ceil(comparison); targetRatio <= 6; targetRatio++) {
            const stats = getUpgradeStats(comparison, targetRatio, startBaseCost, maxRes, yourAge);
            result.rows.push(
              { name: `Upgrade to x${targetRatio}`, val: `${stats.upgrades} upgrades, total cost ${formatLargeNumber(stats.totalCost)}, final upgrade cost ${formatLargeNumber(stats.finalCost)}, possible: ${stats.possible}` }
            );
          }
          
        }
          else {
          const statsHalf = getUpgradeStats(comparison, 0.5, startBaseCost, maxRes, yourAge);
              result.rows.push(
                 { name: `You were unable to reach enemy base health`, val: `${testStat.upgrades} upgrades, total cost ${formatLargeNumber(testStat.totalCost)}, final upgrade cost ${formatLargeNumber(testStat.finalCost)}` }
              )
              result.rows.push(
                { name: `Halfway catch-up (x0.5)`, val: `${statsHalf.upgrades} upgrades, total cost ${formatLargeNumber(statsHalf.totalCost)}, final upgrade cost ${formatLargeNumber(statsHalf.finalCost)}, possible: ${statsHalf.possible}` }
              )
          }
          
          result.rows.push({ name: `Enemy timeline`, val: `Reasonable enemy TL: ${reasonableEnemyTL}` });
        }
        break;
      case "Dungeon Stats":
          const dungeonTL = convertedValues[0];
          const dungeonAge = convertedValues[1];
          result = { rows: [] };
          // Zombies 
          const zombieUnits = `Zombies: Unit 1: ${zombies.quantity[dungeonAge].unit1}, Unit 2: ${zombies.quantity[dungeonAge].unit2}, Unit 3: ${zombies.quantity[dungeonAge].unit3}`;
          const zombie_attk_multi = dungeonTL % 10 === 0 ? Math.pow(1.2, 100*(Math.floor(dungeonTL/10)-1)) : Math.pow(1.2, 100*Math.floor(dungeonTL/10));
          const zombie_unit_type = dungeonTL % 10 === 0 ? 10 : dungeonTL % 10; 
          const zombie_rewards = (dungeonTL * 10 + dungeonAge + 1)/2 + 44;
          const zombie_rewards2 = Math.min(zombie_rewards, 450); 
          const zombie_attk_1 = formatLargeNumber(zombies[zombie_unit_type].attk * zombie_attk_multi);
          const zombie_attk_2 = formatLargeNumber(zombies[zombie_unit_type].attk2 * zombie_attk_multi);
          const zombie_attk_3 = formatLargeNumber(zombies[zombie_unit_type].attk3 * zombie_attk_multi);
          result.rows.push({ 
            name: `${zombieUnits}`,
            val: `Unit 1 attack: ${zombie_attk_1}, Unit 2 attack: ${zombie_attk_2}, Unit 3 attack: ${zombie_attk_3}`});
          // Legends
          result.rows.push({
            name: "Legends",
            val: "No idea, I haven't looked into this one"
          })
          // Bosses 
          const bossType = dungeonTL % 5 === 0 ? 5 : dungeonTL % 5;
          let bossName;
          const boss_multi = Math.pow(1.2, ((dungeonTL - bossType) * 10 + dungeonAge -1))
          let boss_attk1 = bosses[bossType].attk * boss_multi;
          let boss_attk2 = bosses[bossType].attk2 * boss_multi;
          let boss_health; 
          if (bosses[bossType].num){
            boss_health = formatLargeNumber(boss_attk1 * 12 * bosses[bossType].num + boss_attk2 * 6 )
          } else {
            boss_health = formatLargeNumber(boss_attk1 * 12 + boss_attk2 * 6)
          }
          
          boss_attk1 = formatLargeNumber(boss_attk1)
          boss_attk2 = formatLargeNumber(boss_attk2)
          
          let boss_attk1_string;
          let boss_attk2_string;
          if(bosses[bossType].num){
            boss_attk1_string = `Normal attack of ${boss_attk1} (${bosses[bossType].num} times)`;
          } else {
            boss_attk1_string = `Normal attack of ${boss_attk1}`;
          }
          if(bosses[bossType].option){
            boss_attk2_string = `Summons ${bosses[bossType].option} with attack of ${boss_attk2}`;
          } else {
            boss_attk2_string = `AOE attack of ${boss_attk2}`;
          }

          let bossVal;
          if (dungeonTL > 50 || (dungeonTL === 50 && dungeonAge === 10)){
            bossName = `Technically the last level is 50-9, theoretically: ${bosses[bossType].name}`;
            bossVal = `Theoretically ${boss_attk1_string} and ${boss_attk2_string}. Boss health: ${boss_health}`;
          } else {
            bossName = `Boss: ${bosses[bossType].name}`
            bossVal = `Boss stats: ${boss_attk1_string} and ${boss_attk2_string}. Boss health ${boss_health}`;
          }
          result.rows.push({
            name: bossName,
            val: bossVal
          })
          const rewards_string1 = zombie_rewards > zombie_rewards2 ? `${zombie_rewards2} Actual Gems and ${zombie_rewards} in theory` : `${zombie_rewards} Gems`
          const rewards_string2 = dungeonTL > 50 ? `x50 Actual Hero Gear and ${dungeonTL} in theory` : `x${dungeonTL} hero gear`;
          result.rows.push({
            name: "Rewards",
            val: `Zombies: ${rewards_string1}, Legends: 1 Red Potion, Boss: ${rewards_string2} and 1 Yellow Potion`
          })
          break;
      default:
        result = "";
        break;
    }
  
    return result;
  }